import React from "react";
import {
  CheckBoxWrapper,
  CheckBoxLabel,
  CheckBox,
} from "../../StyledComponents/StyledComponents";

const SwitchButton = (props) => {
  return (
    <div>
      <CheckBoxWrapper style={{ marginRight: "10px" }}>
        <CheckBox id={props.id} type="checkbox" {...props} />
        <CheckBoxLabel htmlFor={props.id} {...props} />
      </CheckBoxWrapper>
    </div>
  );
};
export default SwitchButton;
